// validators/phone-validator.js
import { z } from "zod";
import { ValidatorInterface } from "../validator-interface";

export class PhoneValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const message = options.message || "Please enter a valid phone number";
        // Basic North American phone number format regex (adjust as needed for international)
        // Allows optional country code, spaces, dashes, parentheses
        const phoneRegex = /^(?:\+?1[\s.-]?)?\(?([2-9][0-8][0-9])\)?[\s.-]?([2-9][0-9]{2})[\s.-]?([0-9]{4})$/;

        if (baseSchema instanceof z.ZodString) {
            // Add preprocess to remove common formatting characters before validation
            return baseSchema.preprocess(val => String(val).replace(/[\s()\-.]/g, ""), z.string()).regex(phoneRegex, { message });
        } else {
            // eslint-disable-next-line no-console
            console.warn("PhoneValidator applied to non-string schema.");
            // Fallback: ensure string then apply regex
            return z
                .string()
                .preprocess(val => String(val).replace(/[\s()\-.]/g, ""), z.string())
                .regex(phoneRegex, { message })
                .refine(s => baseSchema.safeParse(s).success);
        }
    }

    getErrorMessage(field, options = {}) {
        return options.message || "Please enter a valid phone number";
    }
}
